import { combineReducers } from 'redux';

import fuse from './fuse';
import auth from 'app/auth/store/reducers';

// TODO add all global reducer needs here

import credentials from 'app/main/credentials/store/reducers';
import settings from 'app/main/settings/store/reducers';
import clusters from 'app/main/cluster/store/reducers';
import stacks from 'app/main/stacks/store/reducers';
import marketStack from 'app/main/marketplace/store/reducers';
import jobs from 'app/main/job-manager/store/reducers';
import providers from './providers';
import accounts from 'app/main/account/store/reducers';
import dashboard from 'app/main/dashboard/store/reducers';
import trainings from 'app/main/trainings/store/reducers';
import marketplace from 'app/main/marketplace/store/reducers/marketplace.reducer';
import sessions from './sessions.reducer';
import globalProvision from './globalProvision.reducer';
import storage from './storage.reducer';
import campaigns from 'app/main/campaigns/store/reducers';
// Feature: 001-org-multi-tenancy - Organizations reducer (T031)
import organizations from 'app/main/organizations/store/reducers';
// Cost Research feature for super admin
import costReports from 'app/main/cost-reports/store/reducers';
// Cloud Analyzer - live inventory management (refactored from Cost Reports)
import cloudAnalyzer from 'app/main/cloud-analyzer/store/reducers';
// Interactive walkthrough for first-time users
import walkthroughState from 'app/main/walkthrough/store/reducers';

const createReducer = asyncReducers =>
	combineReducers({
		credentials,
		clusters,
		stacks,
		marketStack,
		settings,
		jobs,
		providers,
		auth,
		fuse,
		accounts,
		dashboard,
		trainings,
		marketplace,
		sessions,
		globalProvision,
		storage,
		campaigns,
		organizations,
		costReports,
		cloudAnalyzer,
		walkthroughState,
		...asyncReducers
	});

export const rootReducer = (asyncReducers) => (state, action) => {
	if (action.type === 'USER_LOGOUT') {
		state = undefined;
	}

	return createReducer(asyncReducers)(state, action);
};

export default createReducer;
